import { type Move } from '../../../../modules/moves'
import { type IdentificationFormValues } from './IdentificationForm.type'

export const moveToFormData = (move: Move): IdentificationFormValues => {
  return move.customer
}
